import {Component} from '@angular/core';
import {SubFormComponent} from '../../_subform';
import {FormBuilder} from '@angular/forms';
import {JobProvider} from '@providers/job/job.provider';

/*
* Блок данных специалиста о должности и работе
* */

@Component({
    providers: [
    ],
    selector: 'specialist-form-fields-job',
    templateUrl: './specialist-form-fields-job.component.html'
})
export class SpecialistFormFieldsJobComponent extends SubFormComponent {

    public formGroupTemplate = this._fb.group({
        job_id: ['custom'], // Id должности. По-умолчанию "Свое название должности"
        job_custom: [''], // Название "Своей" должности, не из справочника
        job_custom_dative: [''], // Название "Своей" должности в родительном
        job_custom_genitive: [''], // Название "Своей" должности в дательном
        serviceRecord: this._fb.group({ // Стаж работы
            years: [''],
            months: ['']
        }),
        file_signature: this._fb.group({ // Подпись
            file_id: [''],
            file_url: ['']
        })
    });

    constructor(
        public jobList: JobProvider,
        private _fb: FormBuilder
    ) {
        super();
    }
}
